// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';

export class PlanningReportingGroup {
  readonly id: string;
  readonly name: string;
  readonly locationIds: string[];

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.locationIds = (data.locationIds ?? []).map((locationIds: any) =>
      locationIds === undefined ? NIL_UUID : locationIds,
    );
  }

  static zero(): PlanningReportingGroup {
    const zeroValues: ExcludeMethodsDeep<PlanningReportingGroup> = {
      id: NIL_UUID,
      name: '',
      locationIds: [],
    };
    return new PlanningReportingGroup(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type PlanningReportingGroupWireFormat = {
  id: string;
  name: string;
  locationIds: string[];
};

type NewPlanningReportingGroupProps = PartialDeep<
  PlanningReportingGroup,
  { recurseIntoArrays: true }
>;
export const NewPlanningReportingGroup: (
  props: NewPlanningReportingGroupProps,
) => PlanningReportingGroup = (props) => new PlanningReportingGroup(props);

type NewPlanningReportingGroupFromWireFormatProps = PartialDeep<
  PlanningReportingGroupWireFormat,
  { recurseIntoArrays: true }
>;
export const NewPlanningReportingGroupFromWireFormat: (
  props: NewPlanningReportingGroupFromWireFormatProps,
) => PlanningReportingGroup = (props) => new PlanningReportingGroup(props);
